export default __webpack_public_path__ + "static/media/ezgif.com-gif-maker (1).8780c2ef.gif";